import React from "react";

import useStyles from "@hooks/useStyles";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import Avatar from "@material-ui/core/Avatar";

const WebsiteQuote = () => {
	const classes = useStyles("Website");

	const backgroundColor = ""; // #ffebe5
	const backgroundGradient = ``; // for testing  linear-gradient(121.04deg,#79dfff 15.69%,#865cff)
	const backgroundImage = ``; // for testing https://wallpapercave.com/wp/wp8377155.jpg
	const coloredBox = false;

	const hasMedia = true;

	const header = `Lessons.com took my training business to the next level. It's by far the best place I get new customers from now.`;
	const subHeader = `Scott T. is a basketball trainer`;

	const reverseOrder = true;
	const textAlign = "left"; // left / center / right

	const image =
		"https://res.cloudinary.com/liaison-inc/image/upload/c_fill,f_webp,q_auto/content/lessons/lessons-basketball-trainer.jpg";

	const video = false;
	const autoPlay = false;

	//const youtubeEmbedUrl = `https://www.youtube.com/embed/${videoId}`;
	const youtubeEmbedUrl = `https://www.youtube.com/embed/L3gOf2XDp8Y`;

	return (
		<React.Fragment>
			<section
				className={
					header || subHeader || hasMedia
						? "websiteComponent"
						: "websiteComponent thin"
				}
				style={{
					backgroundColor:
						!coloredBox && backgroundColor ? backgroundColor : "unset",
					backgroundImage:
						!coloredBox && backgroundGradient ? backgroundGradient : "unset",
				}}
			>
				{backgroundImage && (
					<Box
						position={"absolute"}
						top={0}
						bottom={0}
						width={"100%"}
						style={{
							backgroundImage: `url(${backgroundImage})`,
							backgroundRepeat: "no-repeat",
							backgroundSize: "cover",
							backgroundPosition: "50% 50%",
							opacity: "0.4",
							//filter: "blur(2px)",
						}}
						zIndex={1}
					/>
				)}

				<Container
					maxWidth={hasMedia ? "lg" : "md"}
					disableGutters
					style={{ zIndex: 3 }}
				>
					<div
						className={coloredBox ? classes.featuredTextBox : undefined}
						style={{
							backgroundColor:
								coloredBox && backgroundColor ? backgroundColor : "",
							backgroundImage:
								coloredBox && backgroundGradient ? backgroundGradient : "unset",
						}}
					>
						<Grid
							container
							spacing={8}
							direction={hasMedia ? (reverseOrder ? "row-reverse" : "row") : {}}
						>
							<Grid item xs={12} sm={12} md={hasMedia ? 6 : 12}>
								<Box
									display={"flex"}
									flexDirection={"column"}
									justifyContent={"center"}
									height={"100%"}
									m={
										hasMedia
											? reverseOrder
												? { xs: 0, sm: "0px 0px 0px 40px" }
												: { xs: 0, sm: "0px 40px 0px 0px" }
											: {}
									}
								>
									<Box
										display={"flex"}
										flexDirection={"column"}
										justifyContent={"center"}
										height={"100%"}
									>
										<Box className={classes.quoteSymbol} textAlign={textAlign}>
											“
										</Box>

										<Box className={classes.quoteHead} textAlign={textAlign}>
											{header}
										</Box>

										<Box mt={6} textAlign={textAlign}>
											&mdash; {subHeader}
										</Box>
									</Box>
								</Box>
							</Grid>

							{hasMedia && (
								<Grid item xs={12} sm={12} md={6}>
									{video ? (
										<>
											<div
												className="video-responsive"
												style={{
													position: "relative",
													paddingBottom: "56.25%",
													height: 0,
												}}
											>
												<iframe
													style={{
														position: "absolute",
														top: 0,
														left: 0,
														width: "100%",
														height: "100%",
													}}
													src={
														autoPlay
															? `${youtubeEmbedUrl}?autoplay=1`
															: youtubeEmbedUrl
													}
													frameBorder="0"
													allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
													allowFullScreen
													title="Embedded YouTube Video"
												/>
											</div>
										</>
									) : (
										<Box
											width={"100%"}
											height={"100%"}
											display={"inline-block"}
										>
											<Avatar
												src={image}
												alt="pic"
												imgProps={{
													decoding: "async",
													loading: "lazy",
												}}
												className="picture"
											/>
										</Box>
									)}
								</Grid>
							)}
						</Grid>
					</div>
				</Container>
			</section>
		</React.Fragment>
	);
};

export default WebsiteQuote;
